import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {ProductWastageReportModel} from "./product-wastage-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-product-wastage-report-page",
    templateUrl: "./product-wastage-report-page.component.html",
    providers: [provideReportModel(ProductWastageReportModel)]
})
export class ProductWastageReportPageComponent extends AbstractReportPage {

    constructor(public model: ProductWastageReportModel) {
        super();
    }
}
